// extracted by mini-css-extract-plugin
export default {"sliderWrap":"PointCarousel_sliderWrap__XDiP5","specialSlide":"PointCarousel_specialSlide__Kaltu","carouselContainer":"PointCarousel_carouselContainer__8hZjc"};